/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Route } from 'react-router-dom';

import Dashboard from '../containers/dashboard/pages/Dashboard';
import DataExport from '../containers/data-export/DataExportContainer';

import respondentRoutes from './Respondents/routes';
import assessmentRoutes from './Assessments/routes';
import teamReportRoutes from './TeamReports/routers';
import jobProfileRoutes from './JobProfiles/routes';
import superMatchRoutes from './SuperMatches/routes';
import superLinkRoutes from './SuperLink/routes';
import surveyRoutes from './surveys/routes';
import surveyProjectRoutes from './SurveyProjects/routes';
import executiveReportRoutes from './ExecutiveReports/routes';
import userRoutes from './Users/routes';
import accountsRoutes from './Accounts/routes';
import consumptionRoutes from './consumption/routes';
import transferRoutes from './transfers/routes';
import commercialAgreementRoutes from './CommercialAgreements/routes';

export function RouteWithSubRoutes(route) {
  return (
    <Route
      path={route.path}
      render={(props) => (
        // pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
}

const otherRoutes = [
  {
    exact: true,
    path: '/accounts/:aid/',
    component: Dashboard,
  },
  {
    path: '/accounts/:aid/dashboard',
    component: Dashboard,
  },
  {
    path: '/accounts/:aid/export',
    component: DataExport,
  },
];

export const routes = otherRoutes
  .concat(respondentRoutes)
  .concat(assessmentRoutes)
  .concat(teamReportRoutes)
  .concat(jobProfileRoutes)
  .concat(superMatchRoutes)
  .concat(superLinkRoutes)
  .concat(surveyRoutes)
  .concat(surveyProjectRoutes)
  .concat(executiveReportRoutes)
  .concat(userRoutes)
  .concat(accountsRoutes)
  .concat(consumptionRoutes)
  .concat(transferRoutes)
  .concat(commercialAgreementRoutes);
